// To avoid getting the wrong brand/region value due to DeepSearchResolver behavior in configuration manager
export const brandIdValPath = 'brand.id';
export const regionIdValPath = 'region.id';
export const languageIdValPath = 'language.id';
export const rampFormConfigName = 'rampForm';

// The BUID configuration node that API should look at when handling the request
export const businessUnitConfigNode = 'rampForm';

export const invalidSignInErrorMessage = 'invalidSignInErrorMessage';
export const signInErrorTransKey = 'signInFailureErrorMessage';
export const posNoTransactionMessage = 'posNoTransactionMessage';
export const posGenericErrorMessage = 'posGenericErrorMessage';
export const partialSignUpGenericErrorMessage = 'partialSignUpGenericErrorMessage';
export const completeSignUpGenericErrorMessage = 'completeSignUpGenericErrorMessage';
export const partialUserExistsErrorMessage = 'partialUserExistsErrorMessage';
export const completeUserExistsErrorMessage = 'completeUserExistsErrorMessage';
export const genericErrorMessage = 'genericError';

//constant for local test mock server
export const mockServerBaseUrl = 'https://35b59812-5003-4d3a-9c07-4411a459fd04.mock.pstmn.io';

// The inverse proxy server set up to resolve CORS issue
export const proxyServerBaseUrl = 'http://localhost';

export const integerRegex = new RegExp('^[0-9]*$');
export const placeholderRegex = /::\s*([a-z0-9_]+)\s*::/i;

// Note the format token varies for different date-fns versions
export const dateFnsDateToken = 'yyyyMMdd';

export enum SearchParam {
    REGION = 'region',
    BRAND = 'brand'
}

export const CSRF_TOKEN_COOKIE_NAME = 'csrftoken';
